import { render, staticRenderFns } from "./bugDetermine.vue?vue&type=template&id=db335d5a&scoped=true&"
import script from "./bugDetermine.vue?vue&type=script&lang=js&"
export * from "./bugDetermine.vue?vue&type=script&lang=js&"
import style0 from "./bugDetermine.vue?vue&type=style&index=0&id=db335d5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db335d5a",
  null
  
)

export default component.exports